module.exports = __webpack_public_path__ + "media/Video 129.0ecc9287.mp4";